import { createFileRoute, redirect } from '@tanstack/react-router'
import { SuperAdminTemplateRequests } from '@/views/super-admin/template-requests/index'
import { Main } from '@/components/layout/main'
import { useAuthStore } from '@/stores/authStore'

export const Route = createFileRoute('/_authenticated/super-admin-template-requests')({
  beforeLoad: async () => {
    const auth = useAuthStore.getState().auth
    if (!auth.accessToken || !auth.user) {
      throw redirect({ to: '/auth/login' })
    }
    if (auth.user.role !== 'Super Admin' && auth.user.role_name !== 'Super Admin') {
      throw redirect({ to: '/dashboard' })
    }
  },
  component: Page,
})

function Page() {
  return (
    <Main>
      <SuperAdminTemplateRequests />
    </Main>
  )
}
